import {
	ListBase,
	ListToolbar,
	Pagination,
	useGetIdentity,
	useListContext
} from 'react-admin';
import { Box, Stack } from '@mui/material';
import { ListActions } from '../../../components/ListActions';
import { OBJECTS_TYPES } from '../../../constants';
import { ComplexType } from '../../../types';
import { ComplexCard } from '../ComplexCard';

export const ComplexesList = () => {
	const { identity } = useGetIdentity();
	if (!identity) return null;

	return (
		<ListBase
			resource={OBJECTS_TYPES.COMPLEXES}
			perPage={25}
			sort={{ field: 'created_at', order: 'DESC' }}
		>
			<ComplexesListLayout />
		</ListBase>
	);
};

const ComplexesListLayout = () => {
	const { data } = useListContext();

	return (
		<Stack direction="row" gap={3}>
			<Stack sx={{ width: '100%' }}>
				<Stack sx={{ width: '100%' }}>
					<ListToolbar actions={<ListActions />} />
				</Stack>
				<Box
					mt={2}
					width="100%"
					gap={2}
					display="grid"
					justifyItems="center"
					gridTemplateColumns="repeat(auto-fill, minmax(200px, 1fr))"
				>
					{data?.map((complex: ComplexType) => (
						<ComplexCard key={complex.id} data={complex} />
					))}
				</Box>
				<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
			</Stack>
		</Stack>
	);
};
